export const LOGIN = "/sharp/individual/yearSelection";
export const SIGNUP = "/sharp/individual/yearSelection";
export const GUEST_LOGIN = "/sharp/individual/yearSelectionGuest";
export const YEAR_SELECTION = "/sharp/individual/selectedPlans";
export const PLAN_SELECTION_CONTINUE = "/sharp/individual/enrollOnline";
export const SUBMIT_FORM = "/sharp/individual/Confirmation";
export const DOWNLOAD_PDF = "/sharp/individual/Download";
export const GET_CLINICAL_NAME = "/sharp/individual/clinicName?ofcCde=";
export const SAVE_LOGOUT = "/sharp/individual/Save";
export const FOR_GOT_PD = "/forgotpassword/sendEmail?emailId=";
export const RE_SET_PD = "/password/change";
export const DOWNLOAD_FORM = "/download/pdf";
export const PDF_UPLOAD ="/sharp/individual/updatePdf";
